import React, { useEffect, useRef, useState } from 'react';

/**
 * Görgetésre megjelenő tartalom. Az elem addig áttetsző és lejjebb ül, amíg be
 * nem ér a nézetbe — akkor egyszer felúszik, és utána nem figyeljük tovább.
 *
 * IntersectionObserver nélküli böngészőben (és `prefers-reduced-motion` esetén)
 * azonnal láthatóra vált, tehát tartalom sosem tűnhet el.
 */
export default function Reveal({ children, delay = 0, className = '', as: Tag = 'div' }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    if (!el || reduced || typeof IntersectionObserver === 'undefined') {
      setShown(true);
      return;
    }

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`transition-all duration-700 ease-smooth ${
        shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
      } ${className}`}
      style={{ transitionDelay: shown ? `${delay}ms` : '0ms' }}
    >
      {children}
    </Tag>
  );
}
